import './style.scss';

export default !function () {
  const block = document.querySelector('.price-v10');

  if (!block) {
    return;
  }

  const blockName = block.dataset.blockName || 'Блок без названия'
  const autopaymentTypes = block.querySelector('.price-v10__types');
  const form = block.querySelector('.form');
  const closeErrorButton = block.querySelector('.price-v10__close-error');

  // analytics
  form?.addEventListener('form-sended', (evt) => {
    window?.$analytics.push('price-form-send', {
      requestId: evt.sendingResult?.formData.get('request_id'),
      label: evt.sendingResult?.formData.get('payment_type'),
      blockName
    });
  });

  const priceText = block.querySelector('.price-v10__price-count');

  if (autopaymentTypes) {
    const pushAutopaymentAnalytics = (type) => {
      window.$analytics?.push('price-type-click', {
        action: `Select ${type}`,
        blockName
      });
    };

    autopaymentTypes.addEventListener('change', (evt) => {
      const chosenType = evt.target.value;
      const cost = parseInt(evt.target.dataset.cost).toLocaleString('ru-RU');
      const currency = evt.target.dataset.currency || '₽';

      priceText.textContent = `${cost} ${currency}`

      pushAutopaymentAnalytics(chosenType);
    });
  }

  closeErrorButton?.addEventListener('click', () => {
    document.body.classList.remove('js-payment-error');
  });
}();
